import { createRoot } from "react-dom/client";
import "./styles.css";
import App from "./App";
import { FixedAttributionIcon } from "fixed-attribution-icon";
new FixedAttributionIcon("https://github.com/ektogamat/christmas-threejs");
createRoot(document.getElementById("root")).render(<App />);
